
<template>
  <!-- 官方消息 -->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="messageId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
    <add ref="Model" @updateList = "updateList"></add>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import add from './add.vue';
export default {
  mixins: [fetchSelect],
  components: {
    add
  },
  name: 'officialMsg',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: '标题', inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' },
        { props: ['userType'], placeholder: '用户类型', options: [], inputType: 'select' },
        { props: ['sendDate'], placeholder: ['发布时间', '发布时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', handle: (record) => this.$refs.Model.visible = true, icon: 'plus', permi: ['community:officialMsg:add'] }
      ],
      rowOptList: [
        { text: '编辑', handle: (record) => this.$refs.Model.show(record), permi: ['community:officialMsg:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:officialMsg:delete'] }
      ],
      columns: [
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'userTypeDesc', align: 'left', width: '' },
        { title: '阅读数', dataIndex: 'readNum', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '发布时间', dataIndex: 'sendTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        status: undefined,
        userType: undefined,
        sendDate: undefined
      },
      listApi: {
        url: '/housekeep/message/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/housekeep/message/',
        title: '官方消息',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    updateList () {
      this.$refs.table.getTableList();
    },
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/housekeep_message_status',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
      this.$get({
        url: '/dict/data/dictType/housekeep_message_user_type',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data;
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        el.sendAndRead = `${el.totalNum} | ${el.readNum}`;
      });
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
